import { gql, useQuery } from '@apollo/client'

import {
  ArtistPreSaleLotteryApplicantDetailFragmentDoc,
  ConsoleLotteryManagementDetailQuery,
  ConsoleLotteryManagementDetailQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { router } = useRouter<{ preSaleId: string; userId: string }>()

  const { data } = useQuery<
    ConsoleLotteryManagementDetailQuery,
    ConsoleLotteryManagementDetailQueryVariables
  >(QUERY, {
    variables: {
      userId: router.query.userId,
      preSaleId: router.query.preSaleId,
    },
  })

  return {
    state: {
      artistId: user?.uid ?? '',
      preSaleId: router.query.preSaleId,
      preSaleLotteryApplicant: data?.artistPreSaleLotteryApplicant ?? null,
    },
    actions: {},
  }
})

const QUERY = gql`
  query ConsoleLotteryManagementDetail($preSaleId: String!, $userId: ID!) {
    artistPreSaleLotteryApplicant(preSaleId: $preSaleId, userId: $userId) {
      ...ArtistPreSaleLotteryApplicantDetail
    }
  }
  ${ArtistPreSaleLotteryApplicantDetailFragmentDoc}
`
